import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { indicadoresVivosModulo } from '../../diccionarios/indicadoresVivosModulo';
import { DireccionesUsuariosService } from '../../services/direcciones-usuarios.service';
import { DireccionesService } from '../../services/direcciones.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';

@Component({
  selector: 'app-mantenedor-direcciones-usuarios',
  templateUrl: './mantenedor-direcciones-usuarios.component.html',
  styleUrls: ['./mantenedor-direcciones-usuarios.component.css']
})
export class MantenedorDireccionesUsuariosComponent implements OnInit {

  tituloCard: string = 'Mantenedor Relación Usuario - Modelo Negocio';
  tituloForm: string = 'Lista De Relación Usuario - Modelo Negocio';
  formulario: FormGroup;
  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  cmbDirecciones: any[] = [];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _direccionesUsuarios: DireccionesUsuariosService,
    private _direcciones: DireccionesService,
    private _dmaestros: DatosMaestrosService,
  ) { }

  ngOnInit() {
    this.modulo = indicadoresVivosModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;
    this.formulario = this.fb.group({
      usuario: ['', [Validators.required]],
      codigoUsuario: ['', [Validators.required]],
      nombreUsuario: ['', [Validators.required]],
      codigoDireccion: ['', [Validators.required]]
    });
    this.cargarGridcomponent();
    this.getDireccionesUsuarios();
    this.getDirecciones();
  }

  /* FUNCIONES */
  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'COD.DIRECCION-CANAL',
        field: 'codigoDireccion',
        filter: true,
        width: 200,
      },
      {
        headerName: 'CANAL VENTA',
        field: 'nombreCanalVenta',
        sortable: true,
        width: 200,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'USUARIO',
        field: 'codigoUsuario',
        sortable: true,
        width: 200,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  nuevo() {
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Guardar Relación Usuario - Modelo Negocio';
  }

  // editar({ rowData }) {
  //   const obj = {
  //     codigo: rowData.codigo,
  //     descripcion: rowData.descripcion,
  //   }
  //   this.formulario.setValue(obj);
  //   document.getElementById('buttonAbrirModal').click();
  // }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
        this.guardar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Relación Usuario - Modelo Negocio';
    this.tituloForm = 'Lista De Relación Usuario - Modelo Negocio';
  }

  /** SERVICIOS */
  getDireccionesUsuarios() {
    this.listaVacia = true;
    this.loading = true;
    this._direccionesUsuarios.getDireccionesUsuarios().subscribe((res: any[]) => {
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  getUsuarios() {
    const usuario = this.formulario.get('usuario').value;
    this._direccionesUsuarios.getUsuarios(usuario).subscribe((res: any) => {
      this.formulario.get('nombreUsuario').setValue(res.respuesta.firstName);
      this.formulario.get('codigoUsuario').setValue(res.respuesta.login);
      this._utils.mensajeOKToast('Usuario Encontrado.');
    }, (err) => {
      this.formulario.get('nombreUsuario').setValue('');
      this.formulario.get('codigoUsuario').setValue('');
    });
  }

  clearField() {
    const codigoUsuario = this.formulario.get('codigoUsuario').value;
    if(codigoUsuario.length === 0) {
      this.formulario.get('nombreUsuario').setValue('');
    }
  }

  getDirecciones() {
    this.listaVacia = true;
    this.loading = true;
    
    /*this._direcciones.getDirecciones().subscribe((res: any[]) => {
      this.cmbDirecciones = res;
    }, (err) => {
      this.cmbDirecciones = [];
    });*/

    this._dmaestros.getAllCanalVenta().subscribe((res: any[]) => {
      this.cmbDirecciones = res.map(e=> {e.dscaCanalVenta = e.idCanalVenta +" - "+e.dscaCanalVenta;  return e;});
    }, (err) => {
      this.cmbDirecciones = [];
    });

  }

  eliminar({ rowData }) {
    /*
    this._utils.confirmarAcyncronico(this, { title: this.DAT_MSG.eliminar, text: ``, action: this.DAT_BTNS.eliminar }, () => {
      return this._direccionesUsuarios.deleteDireccionesUsuarios(rowData.codigoUsuario, rowData.codigoDireccion.trim());
    }, () => {
      this.gridApi.updateRowData({ remove: this.gridApi.getSelectedRows() });
    });
     */

    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        text: 'Eliminar usuario ' + rowData.codigoUsuario,
        action: this.DAT_BTNS.eliminar,
        funcion: this._direccionesUsuarios.deleteDireccionesUsuarios(rowData.codigoUsuario, rowData.codigoDireccion.trim()),
      })
      .then((res: any) => {
        this.getDireccionesUsuarios();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }
 

  guardar() {
    const obj = Object.assign({}, this.formulario.value);
    delete obj.nombreUsuario;
    delete obj.usuario;
    this._utils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._direccionesUsuarios.saveDireccionesUsuarios(obj),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getDireccionesUsuarios();
    }).catch((err) => {
      console.log(err);
    });
  }

}
